import { DEFAULT_PAGE_SAZE } from '../../../common/PrimeTable/CustomPrimeTable'
import {
  CREATE_OPPORTUNITY,
  DELETE_OPPORTUNITY,
  GET_OPPORTUNITIES,
  GET_OPPORTUNITY,
  OPPORTUNITY_EDITING,
  OPPORTUNITY_LOADING,
  UPDATE_OPPORTUNITY,
} from './opportunitiesTypes'

const initState = {
  isLoading: false,
  triggerRefresh: false,
  opportunities: {
    data: [],
    query: {
      limit: DEFAULT_PAGE_SAZE,
      first: 0,
      totalRecords: 0,
    },
  },
  isEditing: false,
  opportunity: null,
}

const OpportunitiesReducer = (state = initState, action) => {
  switch (action.type) {
    case OPPORTUNITY_EDITING: {
      return {
        ...state,
        isEditing: action.payload,
      }
    }
    case GET_OPPORTUNITY:
      return {
        ...state,
        opportunity: action.payload,
        isLoading: false,
      }
    case CREATE_OPPORTUNITY: {
      return {
        ...state,
        opportunity: action.payload,
        triggerRefresh: true,
        isLoading: false,
      }
    }
    case GET_OPPORTUNITIES:
      return {
        ...state,
        opportunities: {
          ...action.payload,
        },
        triggerRefresh: false,
        isLoading: false,
        opportunity: null,
      }
    case OPPORTUNITY_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      }
    }
    case DELETE_OPPORTUNITY:
      return {
        ...state,
        triggerRefresh: true,
        isLoading: false,
      }
    case UPDATE_OPPORTUNITY:
      return {
        ...state,
        opportunity: action.payload,
        triggerRefresh: true,
        isLoading: false,
      }
    default:
      return state
  }
}

export default OpportunitiesReducer
